module.exports = __webpack_public_path__ + "assets/img/btn-detail-d26fb601.png";